import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';

import { darkModeAtom } from "../../App";
import DarkMode from "../Utility/DarkMode";

import logo from "../../assets/img/logo/logo-sl-blue.png";
import logoWhite from "../../assets/img/logo/logo-sl-white.png";
import { BsSearch } from "react-icons/bs";

export default function Header() {
    const [darkMode] = useAtom(darkModeAtom);
    const logoSource = darkMode ? logoWhite : logo;
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        setIsSearchOpen(!isSearchOpen);
    }

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        navigate(`/recherche?q=${searchQuery}`);
    }

    return (
        <nav className="mt-5 mb-5">
            <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
                <Link to="/" className="flex items-center space-x-3">
                    <img src={logoSource} className="h-20" alt="Suplib Logo"/>
                    <span className="self-center text-2xl font-semibold whitespace-nowrap"></span>
                </Link>
                <div className="flex items-center md:order-2">
                    <div className="flex items-center justify-center h-full md:order-first md:ml-auto mr-5 md:mr-5 ">
                        <DarkMode />
                    </div>
                    <button type="button" name="searchButton" onClick={toggleMenu} aria-expanded={isMenuOpen} className="inline-flex items-center w-10 h-10 justify-center text-sm rounded-lg md:hidden hover:text-white hover:bg-blue-900 focus:outline-none focus:ring-2 focus:ring-gray-200" aria-controls="navbar-search">
                        <span className="sr-only">Ouvrir le menu</span>
                        <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1h15M1 7h15M1 13h15"/>
                        </svg>
                    </button>
                </div>
                <div className={`items-center justify-between ${isMenuOpen ? 'block' : 'hidden'} w-full md:flex md:w-auto text-center`} id="navbar-search">
                    <ul className="flex flex-col p-4 md:p-0 mt-4 font-medium rounded-lg md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0">
                        <li>
                            <Link to="/" className="block py-2 px-3  rounded hover:text-blue-900">
                                Accueil
                            </Link>
                        </li>
                        <li>
                            <Link to="/a-propos" className="block py-2 px-3  rounded hover:text-blue-900">
                                À propos
                            </Link>
                        </li>
                        <li>
                            <Link to="/recherche-avancee" className="block py-2 px-3  rounded hover:text-blue-900">
                                Recherche avancée
                            </Link>
                        </li>
                        <li>
                            <Link to="/contact" className="block py-2 px-3  rounded hover:text-blue-900">
                                Contact
                            </Link>
                        </li>
                        <div className="relative mt-5 mx-auto md:mt-0 md:mx-0">
                            <form className="flex items-center" onSubmit={handleSearchSubmit}>
                                <label htmlFor="search" className="sr-only">Rechercher un livre</label>
                                <input type="text" placeholder="Rechercher un livre" className="input-text p-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-900" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}/>
                                <button type="submit"
                                        className="p-3 bg-blue-900 hover:bg-blue-800 text-white rounded-md ml-2">
                                    <BsSearch/>
                                </button>
                            </form>
                        </div>
                    </ul>
                </div>
            </div>
        </nav>
    )
}